import { Vue, Options } from 'vue-class-component';
import { SET_ACCOUNT, SET_APP_LOADING } from '@/core/store/action-types';

import DialogReportProblem from './DialogReportProblem/DialogReportProblem.vue';
import { mapGetters } from 'vuex';

@Options({
  name: 'TheHeader',
  components: {
    DialogReportProblem,
  },
  computed: {
    ...mapGetters('UI', ['profilePageEnabled']),
  },
})
export default class TheHeader extends Vue {
  isVisibleDialogReportProblem = false;
  isVisibleDialogProfile = false
  
  get version() {
    return this.$config.FRONTEND_VERSION;
  }

  get iframeProfileSrc () {
    return this.$config.PROFILE_URL;
  }

  changePassword() {
    alert('TBD');
  }

  async logout() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      this.$store.dispatch(SET_ACCOUNT, null);

    import(/* webpackChunkName: "auth-service" */ '@/core/services/auth.service')
      .then(async (authService: any) => {
        await authService.default.logout();
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, true);
    }
  }

  toggleReportProblemDialog() {
    this.isVisibleDialogReportProblem = !this.isVisibleDialogReportProblem;
  }

  toggleDialogProfile() {
    this.isVisibleDialogProfile = !this.isVisibleDialogProfile
  }
}
